(function() {
  'use strict';

  window.ProductDiscount = {
    settings: {
      moneyFormat: window.theme && window.theme.settings && window.theme.settings.moneyFormat ? window.theme.settings.moneyFormat : '${{amount}}'
    },

    currentDiscountData: {
      discountedPrice: 0,
      basePrice: 0,
      discountAmount: 0
    },

    // 事件绑定状态标志
    eventsBound: {
      delegate: false,
      esc: false
    },

    init: function() {
      console.log('ProductDiscount 初始化开始');
      this.setupDiscountCalculation();
      this.bindEvents();
      this.bindModalEvents();
      this.setupQuickShopObserver();
      console.log('ProductDiscount 初始化完成');
    },

    getFlagNewValueFromTitle: function(title) {
      if (!title) return 1;
      
      var titleLower = title.toLowerCase();
      
      if (titleLower.indexOf('bulk human hair') !== -1 || 
          titleLower.indexOf('raw hair clip in') !== -1 || 
          titleLower.indexOf('feather crochet') !== -1) {
        return 2;
      }
      
      if (titleLower.indexOf('raw hair wig') !== -1) {
        return 3;
      }
      
      if (titleLower.indexOf('12a') !== -1) {
        return 4;
      }
      
      if (titleLower.indexOf('tiktok hot') !== -1 || 
          titleLower.indexOf('flash sale') !== -1) {
        return 0;
      }
      
      return 1;
    },

    calculateDiscountedPrice: function(basePriceCents, flagNewValue) {
      var basePriceUSD = basePriceCents / 100;
      var discountAmount = 0;
      
      switch(parseInt(flagNewValue)) {
        case 2:
          discountAmount = basePriceUSD * 0.2;
          break;
        case 3:
          discountAmount = basePriceUSD * 0.3;
          break;
        case 4:
          discountAmount = basePriceUSD * 0.05;
          break;
          case 1:
            default:
              if (basePriceUSD > 349) {
                discountAmount = 100; // Over $349 Get $100 OFF, Code: GRAD100
              } else if (basePriceUSD > 299) {
                discountAmount = 90;  // Over $299 Get $90 OFF, Code: GRAD90
              } else if (basePriceUSD > 199) {
                discountAmount = 60;  // Over $199 Get $60 OFF, Code: GRAD60
              } else if (basePriceUSD > 99) {
                discountAmount = 30;  // Over $99 Get $30 OFF, Code: GRAD30
              } else {
                discountAmount = 0;
              }
              break;
      }
      
      var discountedPrice = Math.max(0, basePriceUSD - discountAmount);
      return Math.round(discountedPrice * 100);
    },

    formatMoney: function(cents) {
      if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
        return window.theme.Currency.formatMoney(cents, this.settings.moneyFormat);
      }
      
      var format = this.settings.moneyFormat;
      var amount = (cents / 100).toFixed(2);
      return format.replace('{{amount}}', amount);
    },

    updateDiscountedPrices: function(variant, productTitle, targetProductSection) {
      var self = this;
      if (!variant) return;
      
      var flagNewValue = this.getFlagNewValueFromTitle(productTitle);
      var discountedPriceCents = this.calculateDiscountedPrice(variant.price, flagNewValue);
      var basePriceCents = variant.price;
      var discountAmountCents = basePriceCents - discountedPriceCents;
      
      this.currentDiscountData = {
        discountedPrice: discountedPriceCents,
        basePrice: basePriceCents,
        discountAmount: discountAmountCents
      };
      
      var productSections = targetProductSection ? [targetProductSection] : document.querySelectorAll('[data-section-type="product"]');
      
      productSections.forEach(function(productSection) {
        var priceBlock = productSection.querySelector('[data-price-block]');
        if (!priceBlock) return;
        
        var tpoPriceEl = priceBlock.querySelector('.tpo_product_price');
        if (tpoPriceEl) {
          tpoPriceEl.remove();
        }
        
        var discountedPriceEl = priceBlock.querySelector('[data-product-discounted-price]');
        var basePriceEl = priceBlock.querySelector('[data-product-base-price]');
        var regularPriceEl = priceBlock.querySelector('[data-product-price]');
        var savePriceEl = priceBlock.querySelector('[data-save-price]');
        
        var shouldShowDiscount = false;
        if (flagNewValue === 2 || flagNewValue === 3 || flagNewValue === 4) {
          shouldShowDiscount = true;
        } else if (flagNewValue === 1 && discountedPriceCents < basePriceCents) {
          shouldShowDiscount = true;
        }
        
        if (shouldShowDiscount) {
          if (!discountedPriceEl) {
            discountedPriceEl = document.createElement('span');
            discountedPriceEl.setAttribute('data-product-discounted-price', '');
            discountedPriceEl.className = 'product__price product__price--discounted';
            
            if (!basePriceEl) {
              basePriceEl = document.createElement('span');
              basePriceEl.setAttribute('data-product-base-price', '');
              basePriceEl.className = 'product__price product__price--original';
              
              if (regularPriceEl) {
                regularPriceEl.parentNode.insertBefore(basePriceEl, regularPriceEl.nextSibling);
              }
            }
            
            if (regularPriceEl) {
              regularPriceEl.parentNode.insertBefore(discountedPriceEl, regularPriceEl);
            }
          }
          
          var formattedDiscountedPrice = self.formatMoney(discountedPriceCents);
          var formattedBasePrice = self.formatMoney(basePriceCents);
          
          discountedPriceEl.innerHTML = formattedDiscountedPrice;
          discountedPriceEl.style.display = '';
          discountedPriceEl.style.visibility = '';
          discountedPriceEl.classList.remove('tpo_product_price');
          
          basePriceEl.innerHTML = formattedBasePrice;
          basePriceEl.style.display = '';
          
          if (regularPriceEl) {
            regularPriceEl.style.display = 'none';
          }
          
          if (savePriceEl) {
            var formattedSavePrice = self.formatMoney(discountAmountCents);
            savePriceEl.innerHTML = 'Save <span class="money">' + formattedSavePrice + '</span>';
            savePriceEl.classList.remove('hide');
          }
          
          var bigDropBtn = priceBlock.querySelector('[data-big-drop-trigger]');
          if (!bigDropBtn && flagNewValue !== 0) {
            bigDropBtn = document.createElement('span');
            bigDropBtn.className = 'big-drop-btn';
            bigDropBtn.setAttribute('data-big-drop-trigger', '');
            bigDropBtn.textContent = 'Big Drop';
            bigDropBtn.style.cssText = 'margin-left: 8px; cursor: pointer; color: #e74c3c; font-weight: bold;';
            
            if (discountedPriceEl.nextSibling) {
              priceBlock.insertBefore(bigDropBtn, discountedPriceEl.nextSibling);
            } else {
              priceBlock.appendChild(bigDropBtn);
            }
          } else if (bigDropBtn) {
            bigDropBtn.style.display = '';
          }
          
        } else {
          if (regularPriceEl) {
            regularPriceEl.style.removeProperty('display');
            regularPriceEl.style.removeProperty('visibility');
            regularPriceEl.style.display = '';
            regularPriceEl.style.visibility = '';
            var formattedPrice = self.formatMoney(basePriceCents);
            regularPriceEl.innerHTML = formattedPrice;
          }
          
          if (discountedPriceEl) {
            discountedPriceEl.style.display = 'none';
          }
          
          if (basePriceEl) {
            basePriceEl.style.display = 'none';
          }
          
          var bigDropBtn = priceBlock.querySelector('[data-big-drop-trigger]');
          if (bigDropBtn) {
            bigDropBtn.remove();
          }
          
          if (savePriceEl) {
            savePriceEl.classList.add('hide');
          }
        }
      }.bind(this));
      
      this.updateModalData();
    },

    updateModalData: function() {
      var modalDiscountedPriceEl = document.querySelector('[data-modal-discounted-price]');
      var modalBasePriceEl = document.querySelector('[data-modal-base-price]');
      var modalDiscountAmountEl = document.querySelector('[data-modal-discount-amount]');
      
      if (modalDiscountedPriceEl) {
        modalDiscountedPriceEl.innerHTML = this.formatMoney(this.currentDiscountData.discountedPrice);
      }
      
      if (modalBasePriceEl) {
        modalBasePriceEl.innerHTML = this.formatMoney(this.currentDiscountData.basePrice);
      }
      
      if (modalDiscountAmountEl) {
        modalDiscountAmountEl.innerHTML = this.formatMoney(this.currentDiscountData.discountAmount);
      }
    },

    bindModalEvents: function() {
      var self = this;
      
      console.log('bindModalEvents 被调用');
      
      // 使用事件委托，绑定到 document 上，这样可以处理所有当前和未来的 Big Drop 按钮
      // 即使现在没有弹窗，也要绑定事件，因为按钮可能稍后才会出现
      if (!this.eventsBound.delegate) {
        console.log('开始绑定 Big Drop 事件委托');
        
        // 绑定所有 Big Drop 按钮点击事件
        document.addEventListener('click', function(e) {
          console.log('document click 事件触发', e.target);
          
          // 查找被点击的按钮（支持嵌套元素）
          var trigger = e.target.closest('[data-big-drop-trigger]');
          console.log('找到的 trigger:', trigger);
          
          if (trigger) {
            e.preventDefault();
            e.stopPropagation();
            console.log('Big Drop 按钮被点击！');
            
            // 查找对应的弹窗（优先查找同级的，找不到就用第一个）
            var modalToOpen = trigger.closest('[data-big-drop-modal]');
            console.log('trigger 最近的 modal:', modalToOpen);
            
            if (!modalToOpen) {
              // 如果是详情页的按钮，查找最近的弹窗
              modalToOpen = document.querySelector('[data-big-drop-modal]');
              console.log('document 中查找 modal:', modalToOpen);
            }
            
            if (modalToOpen) {
              console.log('准备打开弹窗');
              self.openModal(modalToOpen);
            } else {
              console.log('未找到 Big Drop 弹窗 - 请检查弹窗 HTML 是否存在');
            }
          }
          
          // 处理关闭按钮点击
          var closeBtnClicked = e.target.closest('[data-big-drop-close]');
          if (closeBtnClicked) {
            var modalToClose = closeBtnClicked.closest('[data-big-drop-modal]');
            if (modalToClose) {
              e.preventDefault();
              e.stopPropagation();
              self.closeModal(modalToClose);
            }
          }
        });
        
        this.eventsBound.delegate = true;
        console.log('✅ Big Drop 事件委托已绑定到 document');
      } else {
        console.log('Big Drop 事件委托已经绑定过了');
      }
      
      // 为每个已存在的弹窗绑定背景点击关闭
      var modals = document.querySelectorAll('[data-big-drop-modal]');
      console.log('找到弹窗数量:', modals.length);
      
      modals.forEach(function(modal) {
        if (!modal.bigDropBound) {
          modal.addEventListener('click', function(e) {
            if (e.target === modal || e.target.classList.contains('modal__inner')) {
              self.closeModal(modal);
            }
          });
          modal.bigDropBound = true;
        }
      });
      
      // ESC 键关闭（全局只绑定一次）
      if (!this.eventsBound.esc) {
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape') {
            var visibleModals = document.querySelectorAll('[data-big-drop-modal].modal--visible');
            visibleModals.forEach(function(m) {
              self.closeModal(m);
            });
          }
        });
        this.eventsBound.esc = true;
        console.log('✅ ESC 键关闭事件已绑定');
      }
    },

    openModal: function(modal) {
      if (!modal) return;
      modal.classList.add('modal--visible');
      document.body.style.overflow = 'hidden'; // 禁止背景滚动
    },

    closeModal: function(modal) {
      if (!modal) return;
      modal.classList.remove('modal--visible');
      document.body.style.overflow = ''; // 恢复滚动
    },

    setupDiscountCalculation: function() {
      var productSection = document.querySelector('[data-section-type="product"]');
      if (!productSection) return;
      
      var productTitle = productSection.dataset.productTitle || '';
      var variantJsonEl = document.querySelector('[data-current-variant-json]');
      
      if (variantJsonEl && variantJsonEl.textContent.trim()) {
        try {
          var currentVariant = JSON.parse(variantJsonEl.textContent.trim());
          this.updateDiscountedPrices(currentVariant, productTitle, productSection);
        } catch (e) {
          console.error('Error parsing variant JSON:', e);
        }
      }
    },

    bindEvents: function() {
      var self = this;
      var productSection = document.querySelector('[data-section-type="product"]');
      
      if (!productSection) return;
      
      productSection.addEventListener('variantChange', function(evt) {
        if (evt.detail && evt.detail.variant) {
          var productTitle = productSection.dataset.productTitle || '';
          self.updateDiscountedPrices(evt.detail.variant, productTitle, productSection);
        }
      });
      
      productSection.addEventListener('variantPriceChange', function(evt) {
        if (evt.detail && evt.detail.variant) {
          var productTitle = productSection.dataset.productTitle || '';
          self.updateDiscountedPrices(evt.detail.variant, productTitle, productSection);
        }
      });
    },

    setupQuickShopObserver: function() {
      var self = this;
      
      // 方法 1: 监听点击事件
      document.addEventListener('click', function(e) {
        var quickShopBtn = e.target.closest('.js-modal-open-quick-modal, .quick-product__btn');
        if (quickShopBtn) {
          var productId = quickShopBtn.closest('.grid-product')?.dataset.productId || 
                          quickShopBtn.dataset.productId;
          if (productId) {
            // 等待内容加载和 sections 注册完成
            setTimeout(function() {
              self.initQuickShopModal(productId);
            }, 800);
          }
        }
      });
      
      // 方法 2: 监听 sections:loaded 事件
      document.addEventListener('shopify:section:load', function(e) {
        if (e.detail && e.detail.sectionId) {
          setTimeout(function() {
            self.initQuickShopModal();
          }, 300);
        }
      });
    },

    initQuickShopModal: function(targetProductId) {
      var self = this;
      
      console.log('initQuickShopModal 被调用，targetProductId:', targetProductId);
      
      // 查找所有快速购物弹窗
      var quickShopModals = document.querySelectorAll('.modal--quick-shop');
      console.log('找到的快速购物弹窗数量:', quickShopModals.length);
      
      quickShopModals.forEach(function(quickShopModal) {
        // 检查是否有 targetProductId 过滤
        var modalProductId = quickShopModal.dataset.productId;
        if (targetProductId && modalProductId !== targetProductId) return;
        
        // 查找弹窗内的产品区域 - 优先查找 QuickShopHolder 内的
        var quickShopHolder = quickShopModal.querySelector('[id^="QuickShopHolder-"]');
        var productSection = quickShopHolder ? quickShopHolder.querySelector('.product-section') : null;
        
        if (!productSection) {
          productSection = quickShopModal.querySelector('.product-section');
        }
        
        if (!productSection) {
          console.log('未找到 productSection');
          return;
        }
        
        console.log('找到 productSection:', productSection);
        
        // 查找变体选择器
        var variantSelect = productSection.querySelector('select[name="id"]');
        if (!variantSelect) {
          console.log('未找到 variant select');
          return;
        }
        
        // 获取产品信息 - 从多个可能的来源
        var productTitle = productSection.querySelector('[data-product-title]');
        var title = productTitle ? productTitle.dataset.productTitle : '';
        
        // 如果没有找到 title，尝试从 product section 获取
        if (!title) {
          var productHandleElement = productSection.querySelector('[data-product-handle]');
          if (productHandleElement) {
            title = productHandleElement.dataset.productHandle.replace(/-/g, ' ').replace(/\b\w/g, function(l){ return l.toUpperCase() });
          }
        }
        
        console.log('产品标题:', title);
        
        // 初始化当前价格显示
        self.updateQuickShopPrices(variantSelect, title, quickShopModal);
        
        // 移除旧的事件监听器（防止重复绑定）
        var newSelect = variantSelect.cloneNode(true);
        variantSelect.parentNode.replaceChild(newSelect, variantSelect);
        variantSelect = newSelect;
        
        // 绑定变体选择事件
        variantSelect.addEventListener('change', function() {
          setTimeout(function() {
            self.updateQuickShopPrices(variantSelect, title, quickShopModal);
          }, 100);
        });
        
        // 监听其他变体选择器（如果有）
        var optionSelects = productSection.querySelectorAll('select[data-single-option-selector]');
        optionSelects.forEach(function(select) {
          // 移除旧事件
          var newSelect = select.cloneNode(true);
          select.parentNode.replaceChild(newSelect, select);
          
          // 添加新事件
          newSelect.addEventListener('change', function() {
            setTimeout(function() {
              self.updateQuickShopPrices(variantSelect, title, quickShopModal);
            }, 150);
          });
        });
        
        // 为这个产品区域绑定 variantChange 事件
        productSection.addEventListener('variantChange', function(evt) {
          if (evt.detail && evt.detail.variant) {
            console.log('快速购物弹窗中 variantChange 事件触发');
            self.updateDiscountedPrices(evt.detail.variant, title, productSection);
          }
        });
        
        productSection.addEventListener('variantPriceChange', function(evt) {
          if (evt.detail && evt.detail.variant) {
            console.log('快速购物弹窗中 variantPriceChange 事件触发');
            self.updateDiscountedPrices(evt.detail.variant, title, productSection);
          }
        });
        
        // 重新绑定 Big Drop 按钮事件
        setTimeout(function() {
          self.bindModalEvents();
        }, 200);
      });
    },

    updateQuickShopPrices: function(variantSelect, productTitle, modalContainer) {
      if (!variantSelect || !variantSelect.options || variantSelect.selectedIndex < 0) return;
      
      var selectedOption = variantSelect.options[variantSelect.selectedIndex];
      if (!selectedOption) return;
      
      // 尝试从多个来源获取价格
      var variantPrice = null;
      
      // 方法 1: 从 data-price 属性
      if (selectedOption.dataset && selectedOption.dataset.price) {
        variantPrice = selectedOption.dataset.price;
      }
      // 方法 2: 从选项文本中解析（格式："标题 - $XX.XX"）
      else if (selectedOption.text) {
        var match = selectedOption.text.match(/\$(\d+\.?\d*)/);
        if (match) {
          variantPrice = match[1];
        }
      }
      
      if (!variantPrice) {
        console.log('无法获取价格');
        return;
      }
      
      // 解析价格（Shopify 存储为分）
      var priceCents = parseInt(parseFloat(variantPrice) * 100);
      
      if (isNaN(priceCents)) return;
      
      var variant = {
        price: priceCents
      };
      
      // 查找弹窗中的产品区域并更新
      var quickShopProductSection = modalContainer.querySelector('.product-section');
      this.updateDiscountedPrices(variant, productTitle, quickShopProductSection);
      
      // 在快速购物弹窗中查找或创建价格显示区域
      var priceDisplay = modalContainer.querySelector('.quick-shop-price-display');
      if (!priceDisplay) {
        priceDisplay = document.createElement('div');
        priceDisplay.className = 'quick-shop-price-display';
        priceDisplay.style.cssText = 'margin: 15px 0; padding: 10px; background: #f5f5f5; border-radius: 4px; text-align: center;';
        
        var submitButton = modalContainer.querySelector('button[type="submit"]');
        if (submitButton) {
          submitButton.parentNode.insertBefore(priceDisplay, submitButton);
        } else {
          // 如果没有 submit 按钮，添加到表单后面
          var productForm = modalContainer.querySelector('form[action*="/cart/add"]');
          if (productForm) {
            productForm.parentNode.insertBefore(priceDisplay, productForm.nextSibling);
          } else {
            // 如果还没有表单，添加到变体选择器后面
            productForm = modalContainer.querySelector('.product-form, form');
            if (productForm) {
              productForm.parentNode.insertBefore(priceDisplay, productForm.nextSibling);
            }
          }
        }
      }
      
      // 更新价格显示
      var flagNewValue = this.getFlagNewValueFromTitle(productTitle);
      var discountedPriceCents = this.calculateDiscountedPrice(priceCents, flagNewValue);
      var hasDiscount = flagNewValue !== 0 && discountedPriceCents < priceCents;
      
      if (hasDiscount) {
        var formattedDiscounted = this.formatMoney(discountedPriceCents);
        var formattedOriginal = this.formatMoney(priceCents);
        priceDisplay.innerHTML = '<span style="color: #e74c3c; font-weight: 700; font-size: 18px; margin-right: 8px;">' + formattedDiscounted + '</span>' +
                                '<span style="color: #999; text-decoration: line-through; font-size: 14px;">' + formattedOriginal + '</span>' +
                                '<span class="big-drop-btn" data-big-drop-trigger style="margin-left: 8px; cursor: pointer;">Big Drop</span>';
      } else {
        priceDisplay.innerHTML = '<span style="font-size: 18px;">' + this.formatMoney(priceCents) + '</span>';
      }
      
      // 同时更新快速购物弹窗中可能存在的其他价格元素
      var priceElements = modalContainer.querySelectorAll('.product__price, .grid-product__price');
      priceElements.forEach(function(el) {
        // 跳过我们自定义的价格显示区域
        if (el.classList.contains('quick-shop-price-display')) return;
        
        if (hasDiscount) {
          // 如果有折扣，更新为折扣价
          el.innerHTML = '<span class="product__price--discounted" style="color: #e74c3c; font-weight: 700;">' + formattedDiscounted + '</span>' +
                        '<span class="product__price--original" style="color: #999; text-decoration: line-through; margin-left: 8px; font-size: 14px;">' + formattedOriginal + '</span>';
        } else {
          el.innerHTML = '<span>' + this.formatMoney(priceCents) + '</span>';
        }
      }.bind(this));
      
      // 更新快速购物弹窗中的 Big Drop 弹窗数据
      this.updateQuickShopModalData(modalContainer, discountedPriceCents, priceCents);
    },
    
    updateQuickShopModalData: function(modalContainer, discountedPriceCents, basePriceCents) {
      // 计算折扣金额
      var discountAmountCents = basePriceCents - discountedPriceCents;
      
      // 查找快速购物弹窗内的 Big Drop 弹窗
      var quickShopModal = modalContainer.closest('.modal--quick-shop');
      if (!quickShopModal) return;
      
      var bigDropModal = quickShopModal.querySelector('[data-big-drop-modal]');
      if (!bigDropModal) return;
      
      // 更新弹窗中的价格
      var modalDiscountedPriceEl = bigDropModal.querySelector('[data-modal-discounted-price]');
      var modalBasePriceEl = bigDropModal.querySelector('[data-modal-base-price]');
      var modalDiscountAmountEl = bigDropModal.querySelector('[data-modal-discount-amount]');
      
      if (modalDiscountedPriceEl) {
        modalDiscountedPriceEl.innerHTML = this.formatMoney(discountedPriceCents);
      }
      
      if (modalBasePriceEl) {
        modalBasePriceEl.innerHTML = this.formatMoney(basePriceCents);
      }
      
      if (modalDiscountAmountEl) {
        modalDiscountAmountEl.innerHTML = this.formatMoney(discountAmountCents);
      }
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      window.ProductDiscount.init();
    });
  } else {
    window.ProductDiscount.init();
  }
})();
